export const convertVariableToEvCisloTed = (variableId: string) => variableId.replace(/^F(\d+)-0*(\d+)$/, '$2-$1')
export const convertEvCisloTedOld = (oldTedNum: string) => oldTedNum.replace(/^(\d+)\/[^-]+-0*(\d+)$/, '$2-$1')
